import React from 'react';
import { useParams } from 'react-router-dom';
import { ProjectDetailLayout } from '../components/project/ProjectDetailLayout';

interface ProjectDetailPageProps {
  currentUserId?: string;
}

export const ProjectDetailPage: React.FC<ProjectDetailPageProps> = ({
  currentUserId,
}) => {
  const { id } = useParams<{ id: string }>();

  if (!id) {
    return (
      <div className="text-center py-8 text-muted-foreground">
        Brak identyfikatora projektu
      </div>
    );
  }

  return (
    <ProjectDetailLayout projectId={id} currentUserId={currentUserId} />
  );
};
